import React from 'react';
import Renderer from "../renderer";
import { makeStyles } from 'tss-react/mui';
import {Box} from '@mui/system';
import correctSvg from "../../assets/images/quiz/correct.svg";
import wrongSvg from "../../assets/images/quiz/wrong.svg";

const useStyles = makeStyles()((theme) => ({
    container: {
        width: '100%',
        background: 'rgba(243, 248, 251, 1)',
        padding: '0',
        fontWeight: 600,
        color: 'var(--color-black)',
        position: 'relative',
        display: 'flex'
    },
    span: {
        marginRight: '14px',
    },
    renderer: {
        paddingLeft: '46px',
        display: 'block',
    },
    correct: {
        backgroundColor: 'rgba(66, 175, 60, 0.25)',
        display: 'flex',
        width: '100%',
        border: '1px solid rgba(66, 175, 60, 1)!important',
        borderRadius: '8px'
    },
    normal: {
        display: 'flex',
        width: '100%',
        background: 'rgba(243, 248, 251, 1)!important',
        border: '1px solid rgba(205, 230, 245, 1)!important',
        borderRadius: '8px'
    },
    wrong: {
        backgroundColor: 'rgba(255, 0, 0, 0.25)',
        display: 'flex',
        width: '100%',
        border: '1px solid rgba(255, 0, 0, 1)!important',
        borderRadius: '8px',
    },
    label: {
        position: "absolute",
        left: "0",
        top: "0",
        backgroundColor: "var(--mui-palette-common-white)",
        color: "var(--mui-palette-common-black)",
        width: "40px",
        height: "95%",
        textAlign: "center",
        border: "1px solid #CDE6F5",
        borderRadius: "4px",
        fontSize: "20px",
        zIndex: "2",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    correctLabel: {
        backgroundColor: 'transparent',
        border: '1px solid rgba(66, 175, 60, .3)!important',
        borderRadius: '8px',
        borderLeft: 'none'
    },
    wrongLabel: {
        backgroundColor: 'transparent',
        border: '1px solid rgba(255, 0, 0, .3)!important',
        borderRadius: '8px',
        borderLeft: 'none'
    },
}));

export default function Answer({ correct, wrong, className, data, label, content }) {
    const { classes } = useStyles();
    className = className + ' ' + (correct ? classes.correct : (wrong ? classes.wrong : classes.normal));
    let labelClassname = (correct ? classes.correctLabel : (wrong ? classes.wrongLabel : ''));

    return (
        <Box sx={{display: 'flex', alignItems: 'center', my: 0.5}}>
            <div className={"result-answer " + className}>
                {label && <label className='answer-label' style={{ position: 'relative', minHeight: '40px' }}>
                    <span className={`option-label ${labelClassname} ${classes.label}`}>{label}.</span>
                </label>}
                <Renderer
                    content={content}
                    style={styles.renderer}
                    contentType={data.value?.style || 'text'}
                    enableTextToAudio={data.value?.enableTextToAudio}
                    contentUrl={data.value?.contentURL}
                    templateType={data.value?.displayTemplate || 'side-by-side'}
                    overrideHTML={data.value?.overrideHTML}
                />
            </div>
            <div style={{height: '35px', width: '42px', marginLeft: '1rem'}}>
                {(correct || wrong) && <img style={{ height: '100%'}} src={(correct ? correctSvg : (wrong ? wrongSvg : null))} />}
            </div>
        </Box>
    )
}

const styles = {
    container: {
        width: '100%',
        background: 'rgba(243, 248, 251, 1)',
        padding: '0',
        fontWeight: 600,
        color: 'var(--color-black)',
        position: 'relative',
        border: '1px solid rgba(205, 230, 245, .1)'
    },
    span: {
        marginRight: '14px',
    },
    renderer: {
        paddingLeft: '46px',
        display: 'block',
        alignContent: 'center'
    }
}